
import { AuthConfig } from 'angular-oauth2-oidc';

export abstract class AppConfig {
  oauth: AuthConfig;
  authTokenKey: string;
  urlApi: string;
  urlOldAfs: string;
  versionApi: string;
  version: string;
}
